import React from 'react';
import { Color } from '../enums/Color.enum';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { useProductPrice } from '../hooks/useProductPrice';
import { ViewVariant } from '../models/ShopifyVariant.model';
import { ViewProduct } from '../models/ViewProduct.model';
import { cleanPrice } from '../util';

interface Props {
  product: ViewProduct;
  variant?: ViewVariant;
  style?: React.CSSProperties;
  color?: Color;
}

export const ProductPrice: React.FC<Props> = ({ product, variant, style, color }) => {
  const price = useProductPrice(product, variant, color);
  const originalPrice = cleanPrice(product.displayPrice);
  const showStrikeThrough = product.handle !== ProductHandle.EGiftCard && price !== originalPrice;

  return (
    <div style={style}>
      {showStrikeThrough && <span style={{ textDecoration: 'line-through', marginRight: '6px', color: '#666' }}>{originalPrice}</span>}
      {price}
    </div>
  );
};

export default ProductPrice;
